<template>
  <v-card>
    <v-container fluid grid-list-lg>
      <v-layout style="background: #efefef">
        <v-flex sm12 md12 class="align-start">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex sm12 md12 class="align-start">
          <v-list three-line>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>
                  Valor Provisionado: {{ totalProvisioned | formatCurrency }}
                </v-list-tile-title>
                <v-list-tile-title>
                  Valor Recebido: {{ totalReceived | formatCurrency }}
                </v-list-tile-title>
                <v-list-tile-title>
                  Valor Repassado: {{ totalTransfered | formatCurrency }}
                </v-list-tile-title>
                <v-list-tile-title>
                  Valor em Caixa:
                  {{ (totalReceived - totalTransfered) | formatCurrency }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>

      <div class="text-xs-center pt-5" v-if="loadingBillingCS">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>

      <v-data-table
        v-else
        :headers="headers"
        :items="provisionedBillings"
        class="elevation-0"
        :loading="loadingBillingCS"
        :search="search"
        rows-per-page-text="Linhas por página"
        :rows-per-page-items="rowsPerPage"
        no-data-text="Não há valores provisionados"
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <td
            :class="{
              'font-weight-bold': props.item.total_transference_required > 0,
            }"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="props.item.total_transference_required > 0"
                  color="black"
                  size="16"
                  v-on="on"
                  icon
                  style="cursor: default"
                  class="mr-1"
                  >mdi-alert-circle-outline</v-icon
                >
              </template>
              <div>
                <p class="font-weight-bold">
                  Atenção! Esta é uma competência de repasse.
                </p>
              </div>
            </v-tooltip>
            {{ props.item.competence }}
          </td>
          <td
            :class="{
              'font-weight-bold': props.item.total_transference_required > 0,
            }"
          >
            {{ props.item.total_provisioned | formatCurrency }}
          </td>
          <td
            :class="{
              'font-weight-bold': props.item.total_transference_required > 0,
            }"
          >
            {{ props.item.total_received | formatCurrency }}
          </td>
          <td
            :class="{
              'font-weight-bold': props.item.total_transference_required > 0,
            }"
          >
            {{ props.item.total_transfered | formatCurrency }}
          </td>
        </template>

        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Sua busca por "{{ search }}" não encontrou resultados.
          </v-alert>
        </template>
      </v-data-table>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  props: ["consumerUnit"],

  data() {
    return {
      rowsPerPage: [12, 24],
      search: "",
      headers: [
        {
          text: "Competência",
          align: "left",
          sortable: true,
          value: "competence",
        },
        {
          text: "Provisionado",
          align: "center",
          value: "total_provisioned",
        },
        {
          text: "Recebido",
          align: "center",
          value: "total_received",
        },
        {
          text: "Repassado",
          align: "center",
          value: "total_transfered",
        },
      ],
      pagination: {
        sortBy: "competence",
      },
    };
  },

  computed: {
    ...mapGetters("cs", ["provisionedBillings"]),
    ...mapState("cs", ["loadingBillingCS"]),

    totalProvisioned() {
      return this.provisionedBillings.reduce(
        (acc, billing) => acc + billing.total_provisioned,
        0,
      );
    },
    totalReceived() {
      return this.provisionedBillings.reduce(
        (acc, billing) => acc + billing.total_received,
        0,
      );
    },
    totalTransfered() {
      return this.provisionedBillings.reduce(
        (acc, billing) => acc + billing.total_transfered,
        0,
      );
    },
  },

  filters: {
    formatCurrency: (value) => {
      if (!value) return "-";
      return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
  },
};
</script>
